export enum PriceChangeType {
  PERCENTAGE = 'PERCENTAGE',
  PRICE = 'PRICE'
}
